<template>
  <div class="border border-primary p-2">
    <b-tabs content-class="mt-3" @input="onTabChange">
      <b-tab :title="$t('commons.simple_editor')" active
        ><p>
          <hermes-simple-editor v-if="mode == 'S'"></hermes-simple-editor></p
      ></b-tab>
      <b-tab :title="$t('commons.json_editor')" v-if="states.showJsonEditor"
        ><p>
          <hermes-json-editor v-if="mode == 'J'"></hermes-json-editor></p
      ></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { useManageAttributes } from "../../stores/manage-attributes";
export default {
  computed: {
    mode: {
      get() {
        return this.useManageAttributes.mode;
      },
      set(value) {
        this.useManageAttributes.updateMode(value);
      },
    },
    states() {
      return this.useManageAttributes.states;
    },
  },
  methods: {
    onTabChange(tabIndex) {
      this.mode = tabIndex == 0 ? "S" : "J";
    },
  },
  data() {
    return {
      useManageAttributes: useManageAttributes(),
    };
  },
};
</script>
